import Svg, { Circle, Path } from 'react-native-svg';

type ClubhouseLogoProps = {
  size?: number;
  variant?: 'app' | 'mark';
  color?: string;
};

export function ClubhouseLogo({
  size = 40,
  variant = 'app',
  color = '#111111',
}: ClubhouseLogoProps) {
  if (variant === 'mark') {
    return (
      <Svg width={size} height={size * (71 / 65)} viewBox="0 0 65 71" fill="none">
        <Path
          d="M54.6998 2.3116C60.125 5.2331 63.5659 10.7124 64.4938 17.7368C65.4169 24.726 63.8038 32.8162 60.0267 40.682C59.7549 41.2481 59.1168 41.4655 58.6023 41.1671C58.0879 40.8685 57.8908 40.1669 58.1624 39.6008C61.7917 32.0429 63.2504 24.4508 62.4079 18.072C61.5701 11.7288 58.5128 6.94651 53.772 4.39355C48.9966 1.82203 42.6725 1.60096 35.7845 3.94593C28.9037 6.28861 21.9538 11.0287 16.0986 17.4119C10.2434 23.7952 5.87056 31.3994 3.67627 38.9506C1.47981 46.5096 1.62003 53.4726 3.91075 58.7538C6.18491 63.9967 10.5001 67.4081 16.2542 68.3908C22.0406 69.379 28.9512 67.8457 35.852 63.9237C36.3691 63.63 37.0043 63.853 37.2711 64.4214C37.538 64.9899 37.3354 65.6894 36.8183 65.9834C29.636 70.0653 22.2703 71.7637 15.9288 70.6807C9.55525 69.592 4.60978 65.7519 2.00782 59.7532C-0.577517 53.7926 -0.639735 46.1895 1.66864 38.2457C3.97939 30.2938 8.55193 22.3769 14.6156 15.7664C20.6793 9.1558 27.9156 4.19957 35.1623 1.73232C42.4017 -0.732447 49.3089 -0.591343 54.6998 2.3116Z"
          fill={color}
        />
        <Path
          d="M24.3661 50.9474V21.0435H30.1575V50.9474H24.3661ZM35.2302 50.9474V21.0435H40.9794V50.9474H35.2302ZM29.4811 38.149V33.5137H35.9066V38.149H29.4811Z"
          fill={color}
        />
        <Circle cx="54.578" cy="49.5466" r="4.53776" stroke={color} strokeWidth="2" fill="none" />
      </Svg>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 108 108" fill="none">
      <Path
        d="M0 46.046C0 29.7586 0 21.6148 3.21998 15.4161C5.93342 10.1925 10.1925 5.93342 15.4161 3.21998C21.6148 0 29.7586 0 46.046 0H61.954C78.2414 0 86.3851 0 92.5839 3.21998C97.8075 5.93342 102.067 10.1925 104.78 15.4161C108 21.6148 108 29.7586 108 46.046V61.954C108 78.2414 108 86.3851 104.78 92.5839C102.067 97.8075 97.8075 102.067 92.5839 104.78C86.3851 108 78.2414 108 61.954 108H46.046C29.7586 108 21.6148 108 15.4161 104.78C10.1925 102.067 5.93342 97.8075 3.21998 92.5839C0 86.3851 0 78.2414 0 61.954V46.046Z"
        fill="#15803D"
      />
      <Path
        d="M77.5185 19.4335C83.1775 22.4809 86.7668 28.1964 87.7347 35.5236C88.6976 42.8142 87.0149 51.2532 83.075 59.4581C82.7915 60.0486 82.1259 60.2753 81.5892 59.9641C81.0526 59.6527 80.847 58.9208 81.1303 58.3303C84.9161 50.4465 86.4377 42.5272 85.5589 35.8733C84.6849 29.2567 81.4959 24.2682 76.5507 21.6052C71.5694 18.9228 64.9726 18.6922 57.7877 21.1383C50.6103 23.5819 43.3607 28.5264 37.2531 35.1848C31.1455 41.8432 26.5841 49.7753 24.2952 57.652C22.0041 65.5369 22.1503 72.8001 24.5398 78.309C26.912 83.778 31.4133 87.3364 37.4154 88.3614C43.4513 89.3923 50.6598 87.7929 57.8581 83.7018C58.3975 83.3954 59.06 83.628 59.3384 84.2209C59.6167 84.814 59.4055 85.5437 58.8661 85.8502C51.3741 90.1082 43.6908 91.8798 37.076 90.7501C30.4276 89.6145 25.269 85.6088 22.5548 79.3514C19.858 73.1339 19.7931 65.2031 22.201 56.9168C24.6114 48.622 29.3811 40.3639 35.7062 33.4683C42.0312 26.5727 49.5796 21.4028 57.1387 18.8292C64.6902 16.2582 71.8952 16.4054 77.5185 19.4335Z"
        fill="#111111"
      />
      <Path
        d="M45.8771 70.166V38.9729H51.9182V70.166H45.8771ZM57.2096 70.166V38.9729H63.2066V70.166H57.2096ZM51.2126 56.8159V51.9807H57.9151V56.8159H51.2126Z"
        fill="#111111"
      />
      <Circle cx="77.3916" cy="68.7047" r="4.77651" stroke="#111111" strokeWidth="2" fill="none" />
    </Svg>
  );
}
